module.exports = __webpack_public_path__ + "img/BigData3.4a341527.jpg";